/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityRegionFacility } from './FacilityRegionFacility';
import {
    FacilityRegionFacilityFromJSON,
    FacilityRegionFacilityFromJSONTyped,
    FacilityRegionFacilityToJSON,
    FacilityRegionFacilityToJSONTyped,
} from './FacilityRegionFacility';

/**
 * 
 * @export
 * @interface FacilityRegion
 */
export interface FacilityRegion {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_use_count: number;
    /**
     * 
     */
    facilities: Array<FacilityRegionFacility>;
    /**
     * 
     */
    date_created: string;
    /**
     * 
     */
    date_modified: string | null;
    /**
     * 
     */
    updated_by_user?: { [key: string]: any; };
}

/**
 * Check if a given object implements the FacilityRegion interface.
 */
export function instanceOfFacilityRegion(value: object): value is FacilityRegion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('facility_use_count' in value) || value['facility_use_count'] === undefined) return false;
    if (!('facilities' in value) || value['facilities'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('date_modified' in value) || value['date_modified'] === undefined) return false;
    return true;
}

export function FacilityRegionFromJSON(json: any): FacilityRegion {
    return FacilityRegionFromJSONTyped(json, false);
}

export function FacilityRegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityRegion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_use_count': json['facility_use_count'],
        'facilities': ((json['facilities'] as Array<any>).map(FacilityRegionFacilityFromJSON)),
        'date_created': json['date_created'],
        'date_modified': json['date_modified'],
        'updated_by_user': json['updated_by_user'] == null ? undefined : json['updated_by_user'],
    };
}

export function FacilityRegionToJSON(json: any): FacilityRegion {
    return FacilityRegionToJSONTyped(json, false);
}

export function FacilityRegionToJSONTyped(value?: FacilityRegion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'facility_use_count': value['facility_use_count'],
        'facilities': ((value['facilities'] as Array<any>).map(FacilityRegionFacilityToJSON)),
        'date_created': value['date_created'],
        'date_modified': value['date_modified'],
        'updated_by_user': value['updated_by_user'],
    };
}

